export default __webpack_public_path__ + "static/media/default-video-image.de59a694.jpg";